export default __webpack_public_path__ + "static/media/Asset 8.4c4eae22.png";